import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from 'containers/App/context/SchoolyearSchoolProvider';
import useNotification from 'containers/App/Notifications/useNotification';
import { useTranslation } from 'react-i18next';
import { ELEVE_GROUPS_KEY } from './useEleveGroups';
import { EPHEMERAL_GROUPS_KEY } from 'queries/eleveGroups/useEphemeralEleveGroups';

export function useDeleteEleveGroup() {
  const queryClient = useQueryClient();
  const { schoolyear, school } = useSchoolSchoolyear();

  const { notifyError } = useNotification();
  const { t } = useTranslation(['eleve']);

  return useMutation({
    mutationFn: (id: string) =>
      request(
        `/schoolyears/${schoolyear.id}/schools/${school.id}/eleve-groups/${id}`,
        {
          method: 'DELETE',
        },
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [schoolyear.id, school.id, ELEVE_GROUPS_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [schoolyear.id, school.id, EPHEMERAL_GROUPS_KEY],
      });
    },
    onError: () => {
      notifyError({
        title: t('eleve:messages.deleteGroupError'),
      });
    },
  });
}
